export default class BetaFeatureState {

	constructor(
		public name: string,
		public enabled: boolean,
		public switchOn: boolean,
		public enabledForUser: boolean,
	) {}
}
